import { useContext, useState } from "react";
import { useHistory } from "react-router";
import { RESUMEN_YSOCIAL } from "../utils/constants";
import { YsocialContext } from "../contexts/YsocialContext";
import { Direccion } from "../interfaces/direccion.interface";
import { checkearGeolocalizacion } from "../helpers/googleApi";
import { eliminarLocalidadStorage } from "../utils/ubicacionUtils";
import { YsocialActionType } from "../interfaces/global-state/ysocial.action.type.enum";
import { useDirecciones } from "./useDirecciones";

export const useProximidad = () => {
    const history = useHistory();
    const { ysocial, storageManager, dispatchYsocial, useRequest } = useContext(YsocialContext);
    const { apiRequest } = useRequest();
    const { usuario, statusModulos } = ysocial;

    const [proximidadModal, setProximidadModal] = useState(false);
    const [direccionProxima, setDireccionProxima] = useState(null);
    const [localidadError, setLocalidadError] = useState(false);
    const [error, setError] = useState(false);
    const {
        updateDirection,
        foundSelected
    } = useDirecciones({
        socioPrincipal: usuario,
        apiRequest,
        direccionesSocio: usuario.direcciones,
        isYsocial: true
    });

    /**
     * Encargado de validar si existe una direccion mas cercana
     * @param selectedDirection 
     */
    const handleClickValidarProximidad = (selectedDirection) => {
        if (!statusModulos?.deshabilitarGeolocalizacionExacta) {
            checkearGeolocalizacion(usuario.direcciones, selectedDirection, ysocial?.geolocalizacion).then(resultado => {
                if (resultado) {
                    setDireccionProxima(resultado);
                    setProximidadModal(true);
                } else {
                    onClickContinuar(selectedDirection);
                }
            }).catch((error) => {
                console.error("Ocurrió un problema al verificar la geolocalización", error);
                onClickContinuar(selectedDirection);
            })
        } else {
            onClickContinuar(selectedDirection);
        }
    }

    /**
     * Actualiza la direccion seleccionada por proximidad
     */
    const handleClickCambiarDireccionProximidad = () => {
        let direccionAux: Direccion[] = usuario.direcciones;
        direccionAux.forEach(direccion => {
            direccion.seleccionado = (direccion.id === direccionProxima.id)
        });

        const foundAddress = foundSelected(direccionAux);
        updateDirection(direccionAux)
        onClickContinuar(foundAddress);
    }

    const onClickContinuar = (foundAddress = null) => {
        let dirSeleccionada = foundAddress ? foundAddress : foundSelected(usuario.direcciones);

        if (dirSeleccionada.provincia === 'BUENOS AIRES' && (dirSeleccionada.localidad === 'CIUDAD AUTONOMA BUENOS AIRES' || dirSeleccionada.localidad === 'CAPITAL FEDERAL')) {
            if (!localidadError) {
                eliminarLocalidadStorage(storageManager);
                setLocalidadError(true);
            }
        } else {
            actualizarSocioPrincipal(dirSeleccionada);

            dispatchYsocial({
                type: YsocialActionType.actualizarDireccionSeleccionada,
                direccionSeleccionada: dirSeleccionada
            })

            history.push(RESUMEN_YSOCIAL, { dirSeleccionada });
        }
    }


    const actualizarSocioPrincipal = (dirSeleccionada) => {
        let direccionesAux = usuario.direcciones;

        direccionesAux.forEach(direccion => {
            direccion.seleccionado = (direccion.id === dirSeleccionada.id)
        });

        let user = { ...usuario, direcciones: direccionesAux }

        dispatchYsocial({
            type: YsocialActionType.actualizarUsuario,
            socio: user
        })
    }

    return {
        error,
        localidadError,
        proximidadModal,
        direccionProxima,
        handleClickValidarProximidad,
        handleClickCambiarDireccionProximidad,
        onClickContinuar,
        setError,
        setLocalidadError,
        setProximidadModal
    }
}